import { ReactNode, ComponentProps } from 'react';
import { withStyles, Card } from 'vopay';
import { Title, DetailsRows } from 'UI';
import styles from './DetailRowsCard.module.scss';

const cn = withStyles(styles);

type DetailRowsCardProps = ComponentProps<typeof DetailsRows> & {
  title: ReactNode;
};

export default function DetailRowsCard({ title, details }: DetailRowsCardProps) {
  return (
    <Card className={cn('detailRowsCard')}>
      <Title level="4" className={cn('title')}>
        {title}
      </Title>

      <DetailsRows className={cn('rows')} details={details} />
    </Card>
  );
}
